module.exports = __webpack_public_path__ + "static/media/logo.22d924c6.png";